import Action, {GET, POST_FORM, POST, PUT} from "../common/Action";

export const getOperatorAction = new Action('GET_OPERATOR', GET, (params) => `users/Ops/${params.id}`);
export const getOperatorsAction = new Action('GET_OPERATORS', GET, 'users/Ops');
export const addOperatorAction = new Action('ADD_OPERATOR', POST, 'users/create') ;
export const editOperatorAction = new Action('EDIT_OPERATOR', PUT, (params) => `users/${params.id}`) ;
export const changePasswordAction = new Action("CHANGE_PASS", POST, 'users/UpdatePassword');

export const getOperators = () => getOperatorsAction.callApi();
export const getOperator = (id) => getOperatorAction.callApi(null, ({id}));
export const addOperator = (data) => addOperatorAction.callApi(data);
export const editOperator = (id, data) => editOperatorAction.callApi(data, ({id}));
export const changePassword = (userName, password) => changePasswordAction.callApi({userName, password});